export default "__VITE_ASSET__f02b9b1b__"